export class Month {
    ID: number;
    Number: number;
    Name: string;
}

export default Month;